export { PkgComparisonModalV2Module as default } from "./pkg-comparison-modal-v2-module";
export { PkgComparisonModalV2 } from "./pkg-comparison-modal-v2";
export type {
  IPkgCompareModal,
  IBasePkgComparisonModalProps
} from "./pkg-comparison-modal-v2-module";
export type {
  IPackageComparisonModalV2Props
} from "./pkg-comparison-modal-v2";
